export default {
    updated() {
        this.$root.$emit('scrollbarScrollerChatPush')
    }
}
